{
    "Accessibility Menu": "पहुँचियोग्यता मेनू",
    "Reset settings": "सेटिंग रीसेट करें",
    "Close": "बंद करें",
    "Content Adjustments": "सामग्री समायोजन",
    "Adjust Font Size": "फ़ॉन्ट आकार समायोजित करें",
    "Highlight Title": "शीर्षक को हाइलाइट करें",
    "Highlight Links": "लिंक को हाइलाइट करें",
    "Readable Font": "पढ़ने योग्य फ़ॉन्ट",
    "Color Adjustments": "रंग समायोजन",
    "Dark Contrast": "अंधेरा विरोध",
    "Light Contrast": "प्रकाश विरोध",
    "High Contrast": "उच्च विरोध",
    "High Saturation": "उच्च संतुलन",
    "Low Saturation": "निम्न संतुलन",
    "Monochrome": "एकरंग",
    "Tools": "उपकरण",
    "Reading Guide": "पढ़ने का गाइड",
    "Stop Animations": "एनिमेशन रोकें",
    "Big Cursor": "बड़ा कर्सर",
    "Increase Font Size": "फ़ॉन्ट आकार बढ़ाएँ",
    "Decrease Font Size": "फ़ॉन्ट आकार कम करें",
    "Letter Spacing": "अक्षर स्पेसिंग",
    "Line Height": "लाइन की ऊँचाई",
    "Font Weight": "फ़ॉन्ट वेट",
    "Dyslexia Font": "विविधताजनित विपथता फ़ॉन्ट",
    "Language": "भाषा",
    "Open Accessibility Menu": "एक्सेसिबिलिटी मेनू खोलें"
}